import React from "react";
import CareerHero from "../container/careerHero/CareerHero";
import CareerOpening from "../container/careerOpening/CareerOpening";
import CareerSlider from "../container/careerSlider/CareerSlider";
import CareerValues from "../container/careerValues/CareerValues";
import { Helmet } from "react-helmet-async";

const Career = () => {
  return (
    <>
      <Helmet>
        <title>Careers - Radiksez</title>
        <meta
          name="description"
          content="Join Radiksez and be a part of our mission to build a better world. We are looking for talented individuals to join our team."
        />
        <link rel="canonical" href="https://radiksez.com/careers" />
      </Helmet>
      <CareerHero />
      <CareerValues />
      <CareerSlider />
      <CareerOpening />
    </>
  );
};

export default Career;
